<script setup>
import { ref, onMounted, watch, inject, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { __, getDocuments, requestPaymentURL, requestPaymentUpdate, decodeHTMLEntities } from '@/utils'
import WhiteBox from '@components/whiteBox/whiteBox.vue';
import Grid from '@components/grid/grid.vue';
import ScrollList from '@components/scrollList/scrollList.vue';
import AccountDetails from '@components/accountDetails/accountDetails.vue';
import Loader from '@components/loader.vue';
import Modal from "@components/modal.vue";
import FraudModal from "@components/FraudModal.vue";

const documents = ref(null);
const loader = ref(false);
const apiPayment = ref('');
const modal = ref(false);
const route = useRoute();
const router = useRouter();
const loadingUpdate = ref(false);
const fraudAccount = ref(false);
const showfraudAccountPopup = ref(false);

const { features, details } = inject('account');

const accountData = ref(details.value);

const fetchPaymentURL = async () => {
  try {
    const response = await requestPaymentURL('account/#/profile');
    apiPayment.value = response;
    if(response?.data?.error && response?.data?.errorMessage === "fraudulent-account"){
      fraudAccount.value = true;
    }
  } catch (error) {
    console.error('Error fetching payment URL:', error);
  }
};

const togglePopups = () => {

  if(fraudAccount.value){
    showfraudAccountPopup.value = true;
  }else{
    modal.value = true;
  }
}

onMounted(async () => {
    loader.value = true;
    const [data, error] = await getDocuments();
    if(data?.data) {
      documents.value = data.data.sort((a, b) => new Date(b.date_created) - new Date(a.date_created));
    }
    
    try {
      if (route.query.page_status === 'ok_page') {
        loadingUpdate.value = true;
        const [response] = await requestPaymentUpdate(route.query.page_status, route.query.PrivateRequestID);
        

        if(response.data.id) {
          accountData.value = response.data;
          details.value = accountData.value;
        }

        modal.value = false;
        loadingUpdate.value = false;
        router.replace({ path: route.path });
        fetchPaymentURL();
      }
    } catch (error) {
        loadingUpdate.value = false;
      console.error('Error fetching payment URL:', error);
    }

    fetchPaymentURL();
    loader.value = false;
});

watch(() => details.value, (newValue) => {
  accountData.value = newValue;
});

const invoiceShippingMethod = {
	'email' : __('Email')
};
</script>

<template>
    <div class="account-main">
        <Grid columns="2" gap="48" class="account-main-grid">
            <div class="account-main-grid__item">
                <WhiteBox class="white-box--smaller">
                    <AccountDetails />
                </WhiteBox>
            </div>
            <div class="account-main-grid__item">
                <WhiteBox class="white-box--smaller">
                    <div>
                        <template v-if="accountData?.first_name && accountData?.last_name">
                          <strong>בעל כרטיס האשראי:</strong> {{ decodeHTMLEntities(accountData?.first_name) }} {{ decodeHTMLEntities(accountData?.last_name) }}<br />
                        </template>
                        <template v-if="accountData?.four_digits">
                          <strong>4 ספרות אחרונות:</strong> {{ accountData?.four_digits }}<br />
                        </template>
                        <template v-if="accountData?.payment_method">
                          <strong>צורת תשלום:</strong> {{ accountData?.payment_method }}<br />
                        </template>
                    </div>
                    <button type="button" class="details-item-button" @click="togglePopups" v-if="features.paymentEdit">
                        <img class="link-underline" :src="`${theme_path.url}/resources/images/svg/icon-edit2.svg`" /> {{ __('Edit') }}
                    </button>
                </WhiteBox>
            </div>
        </Grid>
        <Loader v-if="loader"  color="#2563eb" />
        <ScrollList v-if="documents"
            :items="documents"
        />
    </div>
    <FraudModal class="popup--contact" :isActive="showfraudAccountPopup" @close="showfraudAccountPopup = false"></FraudModal>
    <Modal :isActive="modal" @close="modal = false" class="popup--subscription">
        <template #head>
            <h3 class="popup__title">
                {{ __('Update payment method') }}
            </h3>
        </template>
        <template #body>
            <p class="details-item-header">{{ __('To update the payment method, please enter the following details') }}</p>
            <Loader v-if="loadingUpdate"  color="#2563eb" />
            <iframe id="payment-iframe" :src="apiPayment?.data?.url" style="width:100%;" frameborder="0" v-if="!loadingUpdate"></iframe>
        </template>
    </Modal>
</template>